/**
 * Gets the current hostname and port of the current browser window.
 */
const getCurrentHostnameAndPort = () => `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;
/**
 * Gets the current scheme (http or https) and host (including port) of the current browser window.
 */
const getCurrentSchemeAndHost = () => `${window.location.protocol}//${getCurrentHostnameAndPort()}`;
const getHostNameInternal = (hostname) => {
    // Short-circuit for developers - they must have the API project running at localhost on port 8088.
    if (hostname.toLowerCase() === "localhost") {
        return "localhost:8088";
    }
    // For our beta and preview environments, we want to use the API hosted at beta.testapi.avisoapp.com, which doesn't
    // match the typical API scheme where you just mash in ".api." to the hostname (see code below). This
    // way we can deploy alpha or beta quality code to the beta.testapi.avisapp.com environment while leaving
    // the production API on our stable code base.
    const hostnameSplit = hostname.split(".");
    if (hostname.toLowerCase().indexOf(".avisoappdev.com") > -1) {
        hostnameSplit.splice(1, 0, "api");
        return hostnameSplit.join(".") + ":8088";
    }
    // For beta and preview environments, use the beta version of the API.
    const previewEnvs = ["beta", "preview"];
    const previewIndex = previewEnvs.indexOf(hostnameSplit[0]);
    if (previewIndex > -1) {
        const env = previewEnvs[previewIndex];
        return `${env}.test-api.avisoapp.com`;
    }
    // app hostname that hosts the React app is {inst}.avisoapp.com
    // hostname for the corresponding API is {inst}.api.avisoapp.com
    hostnameSplit.splice(1, 0, "api");
    return hostnameSplit.join(".");
};
/**
 * Gets the hostname for the API based on the location of the current browser window.
 */
const getApiHostname = () => {
    const hostname = window.location.hostname;
    return getHostNameInternal(hostname);
};
export { getCurrentHostnameAndPort, getCurrentSchemeAndHost, getApiHostname };
